import React, {Fragment, useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next'
import { OpenApi } from '@newageerp/nae-react-auth-wrapper';
import { UIConfig } from '@newageerp/nae-react-ui';
import { SquareButton } from '@newageerp/ui.buttons.base.square-button';
import { TwBackgroundColors } from '@newageerp/ui.styles.tailwind';

import TripOtherCostsForm from '../forms/TripOtherCostsForm';

import { useRecoilState } from "recoil";
import { UserSpaceWrapperToolbarState } from "../../layout/toolbar/UserSpaceWrapperToolbar";
import { useLocation } from 'react-router-dom';

interface Props {
    id: number | string,
    compact?: boolean,

    onSave: (element: any, isNew: boolean, schema: string) => void,
    onCancel: () => void,

    fieldsToReturnOnSave?: string[],

    disableSetTitle?: boolean,

    newStateOptions?: any,
}

export default function TripOtherCostsFormDataSource(props: Props) {
    const location = useLocation<any>()
    const locationState = location.state

    const [, setToolbarTitle] = useRecoilState(UserSpaceWrapperToolbarState)

    const { t } = useTranslation();

    const [hasChanges, setHasChanges] = useState(false)
    const [element, setElement] = useState<any>(null)

    const [saveData, saveDataParams] = OpenApi.useUSave(
        'trip',
        props.fieldsToReturnOnSave ? props.fieldsToReturnOnSave : ['id']
    );
    const doSave = () => {
        if (saveDataParams.loading) {
            return
        }
        const isNew = props.id === 'new'
        setHasChanges(false)
        saveData(element, props.id).then((res: any) => {
            if (res) {
                if (res.error) {
                } else {
                    props.onSave(res.data.element, isNew, 'trip');
                }
            }
        })
    }

    let fieldsToReturn: string[] = [
    "otherCostDriver",
    "otherCostAdr",
    "otherCostLoad",
    "otherCostDowntime"
];
    const [schemaGetData, schemaGetDataParams] = OpenApi.useUList(
        'trip',
        fieldsToReturn
    );
    const getData = () => {
        if (props.id === 'new') {
            schemaGetData(
                { empty: true },
                1,
                1,
                undefined,
                undefined,
                props.newStateOptions ? props.newStateOptions : locationState
            )
        } else {
            schemaGetData([{ and: [['i.id', 'eq', props.id, true]] }], 1, 1)
        }
    }
    useEffect(getData, [])

    useEffect(() => {
        if (schemaGetDataParams.data.records === 1) {
            setElement(schemaGetDataParams.data.data[0])
        }
    }, [schemaGetDataParams.data.data])

    const updateElement = async (key: string, val: any) => {
        let _el = JSON.parse(JSON.stringify(element))
        if (val !== _el[key]) {
            setHasChanges(true)
            _el[key] = val

            _el = await UIConfig.onEditElementUpdate('trip', key, val, _el, updateElement)

            setElement(_el)
        }
    }

    const updateElementBatch =  (updates: any) => {
        let _el = JSON.parse(JSON.stringify(element))
        let _hasChanges = false
        Object.keys(updates).forEach((k: string) => {
            if (updates[k] !== _el[k]) {
                _hasChanges = true
                _el[k] = updates[k]

                _el =  UIConfig.onEditElementUpdate('trip', k, updates[k], _el, updateElement)
            }
        })

        if (_hasChanges) {
            setHasChanges(true)
            setElement(_el)
        }
    }

    useEffect(() => {
        if (!props.disableSetTitle) {
            setToolbarTitle('Kelionės lapas');
        }
    }, []);

    if (!element) {
        return <Fragment/>
    }

    return (
        <Fragment>
            <TripOtherCostsForm
                element={element}
                onChange={updateElement}
                compact={props.compact}
                onSave={doSave}
                onCancel={props.onCancel}
            />
        </Fragment>
    )
}